<template>
  <div>
    <div class="navbar-container" >
      <nav-bar />
    </div>
    <div>
      <app-main />
    </div>
    <div>
      <left-panel/>
    </div>
  </div>
</template>

<script>
import { NavBar, LeftPanel }  from '@/layout/components';
import AppMain from './AppMain';


export default {
  components: { NavBar, AppMain, LeftPanel },
}
</script>


// WEBPACK FOOTER //
// src/views/Home/index.vue